import { initAuth0 } from './auth0';

const studentText = window.studentText || function (key, fallback) {
    return fallback;
  };

window.addEventListener('load', () => {
  const auth = initAuth0({
    domain: window.Auth0Config.domain,
    clientId: window.Auth0Config.clientId,
    redirectUri: window.Auth0Config.redirectUri,
    responseType: window.Auth0Config.responseType,
    passwordlessStartUrl: window.Auth0Config.passwordlessStartUrl,
  });

  const elements = {
    sendCode: document.getElementById('send-code'),
    verifyCode: document.getElementById('verify-code'),
    resendCode: document.getElementById('resend-code'),
    btnLoginWithGoogle: document.getElementById('btn-login-google'),
  };

  ['sendCode', 'resendCode'].forEach((btnId) => {
    const btn = elements[btnId];
    if (btn) {
      btn.addEventListener('click', async function () {
        const email = document.getElementById('user_email').value.trim();

        if (!email) {
          if (btn.querySelector('i')) {
            btn.querySelector('i').setAttribute('class', 'fa fa-envelope envelop-icon');
          }

          btn.removeAttribute('disabled');

          auth.displayError({
            description: studentText('auth_incorrect_password', 'Incorrect password.'),
          });
          return;
        }

        if (btn.querySelector('i')) {
          btn.querySelector('i').setAttribute('class', 'spinner fa fa-spinner fa-spin');
        }

        btn.setAttribute('disabled', true);

        localStorage.setItem('code_timer_start_time', Date.now());

        try {
          await auth.sendCode();

          if (btnId === 'sendCode') {
            window.location.href = '/login/code';
          } else if (btnId === 'resendCode') {
            location.reload();
          }
        } catch (error) {
          auth.displayError(error);

          if (btn.querySelector('i')) {
            btn.querySelector('i').setAttribute('class', 'fa fa-envelope envelop-icon');
          }
          btn.removeAttribute('disabled');
        }
      });
    }
  });

  if (elements.verifyCode) {
    elements.verifyCode.addEventListener('click', async function (e) {
      e.preventDefault();
      const code = Array.from(document.querySelectorAll('.code-input'))
        .map((input) => input.value.trim())
        .join('');
      const emailField = document.getElementById('user_email') ? 'user_email' : 'signup_email';
      const email = document.getElementById(emailField).value.trim();
      if (!code) {
        auth.displayError({
          description: studentText('auth_code_required', 'Please enter the code sent to your email'),
        });
        return;
      }
      await auth.verifyCode(email, code);
    });
  }

  if (elements.btnLoginWithGoogle) {
    elements.btnLoginWithGoogle.addEventListener('click', function () {
      const courseKey = document.querySelector('input[name="course_key[]"]')?.value || '';
      auth.loginWithSocial('google-oauth2', courseKey);
    });
  }

  // var btnLoginWithFacebook = document.getElementById('btn-login-facebook');

  // btnLoginWithFacebook.addEventListener("click", function () {
  // const courseKey = document.querySelector('input[name="course_key[]"]')?.value || '';
  // auth.loginWithSocial('facebook');
  // });
});
